import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossierHistorical/stock/${dossierId}/DossierPhotosComponent`, method: 'GET', token: token })
}
